// src/Routes/PublicRoute.js
// import { Navigate } from "react-router-dom";
// import { isAuthenticated } from "../Utlis/auth";

// const PublicRoute = ({ children }) => {
//   return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
// };

// export default PublicRoute;




import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "../Utlis/auth";

const PublicRoute = ({ children }) => {
  const location = useLocation();

  // Detect ?fromWebsite=true
  const fromWebsite =
    new URLSearchParams(location.search).get("fromWebsite") === "true";

  // If already logged in AND came from website → go to upgrade tab
  if (isAuthenticated() && fromWebsite) {
    return (
      <Navigate
        to="/subscription-plans"
        state={{ activeTab: "upgrade_plans" }}
        replace
      />
    );
  }

  // normal case: logged-in users go to dashboard
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : children;
};

export default PublicRoute;
